import styled from "styled-components";

export const Description = styled.div`
  margin-right: 32px;
`;
